const playing = new Set<HTMLMediaElement>();

export const claimPlayback = (element: HTMLMediaElement): void => {
    for (const other of [...playing]) {
        if (other === element) continue;
        if (!other.isConnected) {
            playing.delete(other);
            continue;
        }
        if (!other.paused) other.pause();
    }
    playing.add(element);
};

export const releasePlayback = (element: HTMLMediaElement): void => {
    playing.delete(element);
};
